import { render, staticRenderFns } from "./SearchService.vue?vue&type=template&id=cfa7dbde"
import script from "./SearchService.vue?vue&type=script&lang=ts"
export * from "./SearchService.vue?vue&type=script&lang=ts"
import style0 from "./SearchService.vue?vue&type=style&index=0&id=cfa7dbde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports